export default {
  title: '¡Únete a {{name}}!',
  default_program_name: 'Club de Recompensas',
  benefits: {
    earn_points: 'Gana puntos con cada pedido',
    get_deals: 'Recibe descuentos exclusivos',
    redeem_points: 'Canjea puntos por comida gratis',
  },
  terms: 'Al registrarte, recibirás ofertas por email y SMS de nuestro&nbsp;',
  buttons: {
    log_in: 'Iniciar sesión',
    sign_up: 'Regístrate',
  },
  labels: {
    already_have_account: '¿Ya tienes cuenta?',
  },
  signup_note:
    'Al registrarte, recibirás ofertas por email y SMS de nuestro <0>restaurante</0> y <1>FoodAmigos</1>, nuestro socio tecnológico. Aceptas nuestros <2>Términos de la plataforma</2> y la <3>Política de privacidad</3>.',
};
